export CommunityLayout from './community';
export DefaultLayout from './default';
export EmptyLayout from './empty';




// WEBPACK FOOTER //
// ./src/layouts/index.js